import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "./../../Constant";
import Swal from "sweetalert2";

export default class Registration extends Component {
  state = {
    email: "",
    password: "",
    userName: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
    institute: "",
    roleList: [],
  };
  componentDidMount() {
    if (window.location.hostname.split('.')[0] !== "livelms") {
      this.setState({ institute: window.location.hostname.split('.')[0] });
      setTimeout(() => {
        this.onSiteList();
      }, 2000);
    }
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSiteList = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", this.state.institute);
    // urlencoded.append("institute", this.state.institute);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/site/isSite", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status == true) {
          // window.location.reload();]
          console.log(result);
          this.setState({
            siteExist: true,
            roleList: result.data.roles,
            roleId: result.data.roles[0].id,
          });
        } else {
          Swal.fire("Error", "Site Not Exist", "error");
        }
      })
      .catch((error) => console.log("error", error));
  };

  onRegistration = (e) => {
    e.preventDefault();

    if (this.state.password !== this.state.confirmPassword) {
      Swal.fire("Error", "Passward is not matched", "error");
      return false;
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", this.state.email);
    urlencoded.append("password", this.state.password);
    urlencoded.append("userName", this.state.userName);
    urlencoded.append("firstName", this.state.firstName);
    urlencoded.append("lastName", this.state.lastName);
    urlencoded.append("mobileNumber", this.state.mobileNumber);
    urlencoded.append("roleId", this.state.roleId);
    urlencoded.append("siteName", this.state.institute);
    // urlencoded.append("institute", this.state.institute);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/user/register", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result)
        if (result.status) {
          Swal.fire("Success", "Register Successfully!", "success");
          // localStorage.setItem("livelms_auth", result.auth);
          // localStorage.setItem("livelms_login", true);
          // localStorage.setItem("livelms_role", "admin");
          window.location.href = "#/";
          window.location.reload();
        } else {
          Swal.fire("Error", result.message, "error");
        }
        console.log(result);


      })
      .catch((error) => console.log("error", error));
  };
  onRoleChange = (e) => {
    console.log(e.target.value);
    this.setState({ roleId: e.target.value });
  };

  render() {
    return (
      <div className="py-3 row m-0">
        <div className="col-md-6 mx-auto bg-white shadow-sm p-5 rounded">
          <h3 className="m-0 text-center text-primary mb-5">Registration</h3>

          <form onSubmit={this.onRegistration}>
            {
              window.location.hostname.split('.')[0] !== "livelms"
                ?
                null
                : <div class="form-group row">
                  <label
                    class="col-form-label text-uppercase col-4 text-right"
                    for="inputDefault"
                  >
                    Domain Name
              </label>
                  <div class="input-group col-4 p-0">
                    <div class=" d-flex">
                      <input
                        type="text"
                        class="form-control p-1 px-2 h-100"
                        placeholder="Enter Domain Name"
                        name="institute"
                        value={this.state.institute}
                        onChange={this.onInputChange}
                        required
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">.livelms.in</span>
                      </div>
                    </div>
                    <div class="invalid-feedback">
                      Sorry, that username's taken. Try another?
                </div>
                  </div>
                  <div className="col-3 ">
                    {this.state.siteExist ? (
                      <div className="btn btn-success" onClick={this.onSiteList}>
                        {" "}
                        <i className="fa fa-check"></i> Exist
                      </div>
                    ) : (
                        <div className="btn btn-dark" onClick={this.onSiteList}>
                          {" "}
                    Check
                        </div>
                      )}
                  </div>
                </div>
            }
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right"
                for="inputDefault"
              >
                Email
              </label>
              <div className="col-6 p-0">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Enter Email"
                  name="email"
                  value={this.state.email}
                  onChange={this.onInputChange}
                  required
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right"
                for="inputDefault"
              >
                First Name
              </label>
              <div className="col-6 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter First Name"
                  name="firstName"
                  value={this.state.firstName}
                  onChange={this.onInputChange}
                  required
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right"
                for="inputDefault"
              >
                Last Name
              </label>
              <div className="col-6 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Last Name"
                  name="lastName"
                  value={this.state.lastName}
                  onChange={this.onInputChange}
                  required
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right"
                for="inputDefault"
              >
                Username
              </label>
              <div className="col-6 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Username"
                  name="userName"
                  value={this.state.userName}
                  onChange={this.onInputChange}
                  required
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right"
                for="inputDefault"
              >
                Password
              </label>
              <div className="col-6 p-0">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Enter Password"
                  name="password"
                  value={this.state.password}
                  onChange={this.onInputChange}
                  required
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right pl-0"
                for="inputDefault"
              >
                Confirm Password
              </label>
              <div className="col-6 p-0">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Enter Confirm Password"
                  name="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.onInputChange}
                  required
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-4 text-right pl-0"
                for="inputDefault"
              >
                Role
              </label>
              <div className="col-6 p-0">
                <select
                  type="password"
                  class="form-control"
                  placeholder="Enter Confirm Password"
                  name="confirmPassword"
                  value={this.state.roleId}
                  onChange={this.onRoleChange}
                  required
                >
                  {this.state.roleList.map((role) => (
                    <option value={role.id}>{role.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row pt-3">
              <div className="col-4"></div>
              <div className="col-6 p-0">
                <input
                  type="submit"
                  className="btn btn-bg text-uppercase font-weight-bold rounded shadow-sm btn-primary"
                  value="Register"
                  onClick={this.onRegistration}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
